import { useFetch } from '@/hooks/useFetch'
import { Controller } from 'react-hook-form'
import { Select } from 'alurkerja-ui'
import { useContext, useEffect, useState } from 'react'
import { CustomComponentContext, CustomComponentContextType } from '@/utils/contexts/CustomComponentContext'

interface IEmployeeNamesData {
  id: number
  name: string
  workEmail: string
  jobName: string
}

export default function ListEmployeeName() {
  const { data: employeeNamesData, isLoading: employeeNamesIsLoading } = useFetch({
    path: '/api/v1/odoo/users',
  })

  const [employeeNames, setEmployeeNames] = useState<IEmployeeNamesData[]>([])

  const { setValue, control } = useContext<CustomComponentContextType>(CustomComponentContext)

  const classNamesLabel = "after:content-['*'] after:text-red-400 after:text-sm font-medium"

  useEffect(() => {
    if (employeeNamesData && Array.isArray(employeeNamesData)) {
      const formattedData = employeeNamesData.map(
        (item: any) =>
          ({
            id: item.id,
            name: item.name,
            workEmail: item.workEmail,
            jobName: item.jobName,
          } as IEmployeeNamesData),
      )

      setEmployeeNames(formattedData)
    }
  }, [employeeNamesData])

  const handleEmployeeNameChange = (value: any) => {
    // Set the selected employee name
    const selectedEmployee = employeeNames.find(item => item.id === value.value)

    if (selectedEmployee) {
      const username = selectedEmployee.workEmail.split('@')[0]

      // Set the form values
      setValue('EMPLOYEE_NAME', selectedEmployee.name)
      setValue('employeeUsername', username)
      setValue('EMPLOYEE_JOB', selectedEmployee.jobName)
    }
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="grid space-x-2">
        <div data-testid="EMPLOYEE_NAME">
          <label htmlFor="EMPLOYEE_NAME" className={classNamesLabel}>
            Nama Karyawan
          </label>
          <Controller
            name={'EMPLOYEE_NAME'}
            control={control}
            render={({ fieldState }) => {
              return (
                <>
                  <Select
                    id="EMPLOYEE_NAME"
                    aria-label="Nama Karyawan"
                    options={employeeNames.map(item => ({
                      value: item.id,
                      label: item.name,
                    }))}
                    isLoading={employeeNamesIsLoading}
                    onChange={value => handleEmployeeNameChange(value)}
                  />
                  {fieldState.error && <p className="text-sm text-red-500">{fieldState.error.message}</p>}
                </>
              )
            }}
          ></Controller>
        </div>
      </div>
    </div>
  )
}
